import type React from 'react'
import type { Recipe } from '../../services/api'

interface Props {
    state: {
        name: string
        nbPersons: number
        durationDays: number
        mealsPerDay: number
        selectedRecipes: Recipe[]
    }
    update: (patch: Partial<Props['state']>) => void
    onNext: () => void
}

const DURATION_OPTIONS = [
    { label: '2 jours', value: 2 },
    { label: '3 jours', value: 3 },
    { label: '1 semaine', value: 7 },
    { label: '2 semaines', value: 14 },
    { label: '1 mois', value: 30 },
]

const Stepper = ({ label, value, min, max, onChange }: { label: string; value: number; min: number; max: number; onChange: (v: number) => void }) => (
    <div className="form-group">
        <label className="form-label">{label}</label>
        <div className="stepper-full">
            <button className="stepper-btn" onClick={() => onChange(Math.max(min, value - 1))}>−</button>
            <span className="stepper-val">{value}</span>
            <button className="stepper-btn" onClick={() => onChange(Math.min(max, value + 1))}>+</button>
        </div>
    </div>
)

export default function Step0Config({ state, update, onNext }: Props) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            <div style={{ padding: '20px', background: 'var(--primary-glow)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--primary)', textAlign: 'center' }}>
                <h3 style={{ color: 'var(--primary)', marginBottom: 8 }}>Configuration de votre liste</h3>
                <p style={{ fontSize: '0.9rem', color: 'var(--primary-light)', opacity: 0.9 }}>
                    Définissez la base de votre planification avant de choisir vos plats.
                </p>
            </div>

            {/* List name */}
            <div className="form-group">
                <label className="form-label">Nom de la liste</label>
                <input 
                    className="input" 
                    value={state.name} 
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => update({ name: e.target.value })} 
                    placeholder="Ex: Courses de la semaine" 
                />
            </div>

            {/* Duration */}
            <div className="form-group">
                <label className="form-label">Durée de planification</label>
                <div className="chips">
                    {DURATION_OPTIONS.map((opt: { label: string; value: number }) => (
                        <button 
                            key={opt.value} 
                            className={`chip ${state.durationDays === opt.value ? 'selected' : ''}`} 
                            onClick={() => update({ durationDays: opt.value })}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Persons + meals */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                <Stepper 
                    label="Nombre de personnes" 
                    value={state.nbPersons} 
                    min={1} 
                    max={20} 
                    onChange={v => update({ nbPersons: v })} 
                />
                <Stepper 
                    label="Repas par jour" 
                    value={state.mealsPerDay} 
                    min={1} 
                    max={5} 
                    onChange={v => update({ mealsPerDay: v })} 
                />
            </div>

            <div style={{ marginTop: 12 }}>
                <button
                    className="btn btn-primary btn-full"
                    onClick={onNext}
                    style={{ padding: '16px' }}
                >
                    Continuer vers la sélection des plats →
                </button>
            </div>
        </div>
    )
}
